// module_configs/pos.js
import React from 'react';
import { 
  faGaugeHigh, faUsers, faUserPlus, faUsersLine, faBuilding, faUserTie,
  faBuildingUser, faUserGroup, faIdCard, faListAlt, faBoxes, faTruckFast,
  faCartPlus, faFileInvoice, faReceipt, faArrowRotateLeft, faRotateLeft,
  faListCheck, faQrcode, faPrint, faCartShopping, faClipboardList,
  faArrowRightArrowLeft, faMoneyBillWave, faPlus, faGear, faBullhorn,
  faLayerGroup, faCog, faCashRegister, faUsersCog, faClock, faCube,
} from '@fortawesome/free-solid-svg-icons';

// Import POS components
import DashboardHome from '.././module_salanty/Dashboard/Dashboard_POS';

import AddCustomer from '.././module_mechanics/mechanics_customer';

import CustomerList from '.././module_mechanics/mechanics_customer_list';

import AddSupplier from '.././module_mechanics/mechanics_Supplier';

import SupplierList from '.././module_mechanics/mechanics_SuppliersList';

import AddEmployee from '.././module_mechanics/mechanics_employees';

import MecEmployeeList from '.././module_mechanics/mechanic_employeelist';

import AddProduct from '.././module_mechanics/mechanics_Products';

import ProductsList from '.././module_mechanics/mechanics_ProductsList';

import AddPurchase from '.././module_mechanics/mechanics_Purchases';

import PurchasesList from '.././module_mechanics/mechanics_PurchaseList';

import AddMecSales from '.././module_mechanics/mechanics_Sell';

import MecSalesList from '.././module_mechanics/mechanics_SellList';

import AddMecReturn from '.././module_mechanics/mechanics_Return';

import MecReturnsList from '.././module_mechanics/mechanics_ReturnList';

import MechanicsBarcode from '.././module_mechanics/mechanics_BarcodeGenerator';

import RootUsers from '.././module_roots/RootUsers';

import MessageSystem from '.././module_roots/MessageSystem';

import CosmeticsSupplierPurchases from '.././module_cosmetics/cosmetics_PurchasesSupplierwise';

import CosmeticsInvoicePurchaseList from '.././module_cosmetics/cosmetics_InvoicePurchaseList';

import CosmeticsTransactions from '.././module_cosmetics/cosmetics_transactions';


export const posConfig = {
  moduleId: 'pos',
  moduleName: 'POS',
  icon: faCashRegister,
  description: 'Point of Sale Management System',
  
  dashboardComponent: DashboardHome,
  
  roles: {
    'admin_pos': { level: 1, label: 'Admin', color: '#6366f1' },
    'manager_pos': { level: 2, label: 'Manager', color: '#4f46e5' },
    'user_pos': { level: 3, label: 'User', color: '#4338ca' },
    'viewer_pos': { level: 4, label: 'Viewer', color: '#3730a3' }
  },
  
  menuGroups: [
    { id: 'management', name: 'Management', icon: faUsersCog, order: 1 },
    { id: 'inventory', name: 'Inventory & Stock', icon: faBoxes, order: 2 },
    { id: 'sales', name: 'Sales & Transactions', icon: faMoneyBillWave, order: 3 },
    { id: 'system', name: 'System Settings', icon: faCog, order: 4 }
  ],
  
  menus: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faGaugeHigh,
      component: DashboardHome,
      roles: ['all'],
      groupId: 'management',
      position: 0
    },
    {
      id: 'customers',
      label: 'Customers',
      icon: faUsers,
      roles: ['admin_pos', 'manager_pos', 'user_pos'],
      groupId: 'management',
      position: 1,
      submenus: [
        {
          id: 'addcustomer',
          label: 'Add Customer',
          component: AddCustomer,
          icon: faUserPlus,
          roles: ['admin_pos', 'manager_pos', 'user_pos']
        },
        {
          id: 'customerlist',
          label: 'Customer List',
          component: CustomerList,
          icon: faUsersLine,
          roles: ['admin_pos', 'manager_pos', 'user_pos']
        }
      ]
    },
    {
      id: 'suppliers',
      label: 'Suppliers',
      icon: faBuilding,
      roles: ['admin_pos', 'manager_pos', 'user_pos'],
      groupId: 'management',
      position: 2,
      submenus: [
        {
          id: 'addsupplier',
          label: 'Add Supplier',
          component: AddSupplier,
          icon: faUserTie,
          roles: ['admin_pos', 'manager_pos', 'user_pos']
        },
        {
          id: 'supplierlist',
          label: 'Supplier List',
          component: SupplierList,
          icon: faBuildingUser,
          roles: ['admin_pos', 'manager_pos', 'user_pos']
        }
      ]
    },
    {
      id: 'employees',
      label: 'Employees',
      icon: faUserGroup,
      roles: ['admin_pos', 'manager_pos'],
      groupId: 'management',
      position: 3,
      submenus: [
        {
          id: 'addemployees',
          label: 'Add Employee',
          component: AddEmployee,
          icon: faUserPlus,
          roles: ['admin_pos', 'manager_pos']
        },
        {
          id: 'employeeslist',
          label: 'Employees List',
          component: MecEmployeeList,
          icon: faIdCard,
          roles: ['admin_pos', 'manager_pos']
        }
      ]
    },
    {
      id: 'products',
      label: 'Products',
      icon: faBoxes,
      roles: ['admin_pos', 'manager_pos', 'user_pos'],
      groupId: 'inventory',
      position: 4,
      submenus: [
        {
          id: 'addproduct',
          label: 'Add Product',
          component: AddProduct,
          icon: faCube,
          roles: ['admin_pos', 'manager_pos', 'user_pos']
        },
        {
          id: 'productslist',
          label: 'Products List',
          component: ProductsList,
          icon: faListAlt,
          roles: ['admin_pos', 'manager_pos', 'user_pos']
        }
      ]
    },
    {
      id: 'purchases',
      label: 'Purchase',
      icon: faTruckFast,
      roles: ['admin_pos', 'manager_pos', 'user_pos'],
      groupId: 'inventory',
      position: 5,
      submenus: [
        {
          id: 'addpurchase',
          label: 'New Purchase',
          component: AddPurchase,
          icon: faCartPlus,
          roles: ['admin_pos', 'manager_pos', 'user_pos']
        },
        {
          id: 'purchaselist',
          label: 'Purchases List',
          component: PurchasesList,
          icon: faFileInvoice,
          roles: ['admin_pos', 'manager_pos', 'user_pos']
        },
        {
          id: 'purchasessupplierwise',
          label: 'Supplier-wise',
          component: CosmeticsSupplierPurchases,
          icon: faBuilding,
          roles: ['admin_pos', 'manager_pos', 'user_pos']
        },
        {
          id: 'purchasesinvoicewise',
          label: 'Bill-wise',
          component: CosmeticsInvoicePurchaseList,
          icon: faReceipt,
          roles: ['admin_pos', 'manager_pos', 'user_pos']
        }
      ]
    },
    {
      id: 'sales',
      label: 'Sales',
      icon: faCartShopping,
      roles: ['admin_pos', 'manager_pos', 'user_pos'],
      groupId: 'sales',
      position: 6,
      submenus: [
        {
          id: 'addsale',
          label: 'New Sale',
          component: AddMecSales,
          icon: faCartPlus,
          roles: ['admin_pos', 'manager_pos', 'user_pos']
        },
        {
          id: 'saleslist',
          label: 'Sales List',
          component: MecSalesList,
          icon: faClipboardList,
          roles: ['admin_pos', 'manager_pos', 'user_pos']
        }
      ]
    },
    {
      id: 'returns',
      label: 'Returns',
      icon: faArrowRotateLeft,
      roles: ['admin_pos', 'manager_pos', 'user_pos'],
      groupId: 'inventory',
      position: 7,
      submenus: [
        {
          id: 'addreturn',
          label: 'New Return',
          component: AddMecReturn,
          icon: faRotateLeft,
          roles: ['admin_pos', 'manager_pos', 'user_pos']
        },
        {
          id: 'returnlist',
          label: 'Return List',
          component: MecReturnsList,
          icon: faListCheck,
          roles: ['admin_pos', 'manager_pos', 'user_pos']
        }
      ]
    },
    {
      id: 'transactions',
      label: 'Transactions',
      icon: faArrowRightArrowLeft,
      roles: ['admin_pos', 'manager_pos'],
      groupId: 'sales',
      position: 8,
      submenus: [
        {
          id: 'transactionsmanager',
          label: 'Transactions',
          component: CosmeticsTransactions,
          icon: faMoneyBillWave,
          roles: ['admin_pos', 'manager_pos']
        }
      ]
    },
    {
      id: 'barcode',
      label: 'Barcodes',
      icon: faQrcode,
      roles: ['admin_pos', 'manager_pos', 'user_pos'],
      groupId: 'inventory',
      position: 9,
      submenus: [
        {
          id: 'barcodeprinting',
          label: 'Barcode Printing',
          component: MechanicsBarcode,
          icon: faPrint,
          roles: ['admin_pos', 'manager_pos', 'user_pos']
        }
      ]
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: faGear,
      component: RootUsers,
      roles: ['admin_pos'],
      groupId: 'system',
      position: 10,
      submenus: []
    },
    {
      id: 'systemupdates',
      label: 'Notifications Center',
      icon: faBullhorn,
      component: MessageSystem,
      roles: ['admin_pos', 'manager_pos', 'user_pos'],
      groupId: 'system',
      position: 11,
      submenus: []
    }
  ],
  
  quickStats: [
    { id: 'todaySales', label: "Today's Sales", icon: 'faChartLine', value: '$4,500' },
    { id: 'orders', label: 'Orders', icon: 'faShoppingCart', value: 89 },
    { id: 'customers', label: 'Customers', icon: 'faUsers', value: 45 },
    { id: 'pending', label: 'Pending', icon: 'faClock', value: 3 }
  ],
  
  shortcuts: [
    { key: 'Alt + D', description: 'Dashboard' },
    { key: 'Alt + C', description: 'Add Customer' },
    { key: 'Alt + L', description: 'Customer List' },
    { key: 'Alt + P', description: 'Products List' },
    { key: 'Alt + S', description: 'New Sale' },
    { key: 'Alt + U', description: 'New Purchase' },
    { key: 'Alt + R', description: 'New Return' },
    { key: 'Alt + E', description: 'Add Employee' },
    { key: 'Alt + B', description: 'Barcode Printing' },
    { key: 'Ctrl + R / Cmd + R', description: 'Refresh Dashboard Data' },
    { key: 'Alt + H', description: 'Toggle Shortcuts Panel' }
  ]
};